import { getAccessToken, getPaymentsForm } from '../../../selectors/biasharaFlexi/payment';
import { getIsApiPending } from '../../../selectors/biasharaFlexi/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/biasharaFlexi/payloadCollection';
import {
    getCompanyDetailsForm,
    getCompanyIdValue,
    getQuoteIdValue,
} from '../../../selectors/biasharaFlexi/companyDetails';
import axios from 'axios';
import { apiTransitionBiasharaFlexiCompanyDetailsForm } from '../../../actions/biasharaFlexi/companyDetails';

export const saveCompanyDetails = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            store.dispatch(apiTransitionBiasharaFlexiCompanyDetailsForm.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(apiTransitionPayloadCollection.initial());
                    store.dispatch(apiTransitionBiasharaFlexiCompanyDetailsForm.success());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.initial());
                store.dispatch(apiTransitionBiasharaFlexiCompanyDetailsForm.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const cid = getCompanyIdValue(state);
    const qid = getQuoteIdValue(state);
    const companyDetails = getCompanyDetailsForm(state);
    const payments = getPaymentsForm(state);

    const payload = {
        companyId: cid.value,
        quoteId: qid.value,
        companyName: companyDetails.companyName.value || 'N/A',
        companyEmail: companyDetails.email.value || 'N/A',
        companyPhoneNumber: companyDetails.mobileNumber.value || 'N/A',
        companyKraPin: companyDetails.kraPinNumber.value || 'N/A',
        companyCityAddress: companyDetails.city.value || 'N/A',
        companyStreetAddress: companyDetails.streetAddress.value || 'N/A',
        companyBuilding: companyDetails.building.value || 'N/A',
        companyPostalAddress: companyDetails.postalBox.value || 'N/A',
        companyPostalCode: companyDetails.postalCode.value || 'N/A',
        FirstName: companyDetails.firstName.value || 'N/A',
        LastName: companyDetails.lastName.value || 'N/A',
        IdNumber: companyDetails.idNumber.value || 'N/A',
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/biashara-flexi/save-company-details';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};
